import { z } from "zod";

export const smbAssetDecisionSchema = z.enum(["approved", "dropped"]);
export const smbAssetReviewInputSchema = z.object({
  assetKey: z.string().regex(/^[a-f0-9]{64}$/),
  decision: smbAssetDecisionSchema,
  expectedDecision: smbAssetDecisionSchema.nullable(),
}).strict();
export const smbGenerationViewSchema = z.object({
  runId: z.string().nullable(), status: z.string(), orderStatus: z.string(),
  costUsd: z.number().nullable(), costCapUsd: z.string().nullable(),
  admissionThresholdOnly: z.literal(true), inFlightMayExceedThreshold: z.literal(true),
  humanReviewRequired: z.literal(true), terminal: z.boolean(), canReady: z.boolean(),
  shortfalls: z.array(z.string()), pendingReviews: z.number(),
  retrySupported: z.literal(false),
  personas: z.array(z.object({ id: z.string(), name: z.string() })),
  counts: z.object({ pending: z.number(), generating: z.number(), ready: z.number(), failed: z.number() }),
  items: z.array(z.object({
    id: z.string(), personaId: z.string(), tool: z.string(), state: z.string(),
    detail: z.string().nullable(), error: z.string().nullable(),
    assets: z.array(z.object({
      assetKey: z.string(), type: z.enum(["image", "video"]), url: z.string(),
      name: z.string().nullable(), decision: smbAssetDecisionSchema.nullable(),
    })),
  })),
});
export type SmbGenerationView = z.infer<typeof smbGenerationViewSchema>;
